var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.25 3.5A3.75 3.75 0 0 0 3.5 7.25v9.5a3.75 3.75 0 0 0 3.75 3.75h9.5a3.75 3.75 0 0 0 3.75-3.75v-9.5a3.75 3.75 0 0 0-3.75-3.75h-9.5ZM5 7.25A2.25 2.25 0 0 1 7.25 5h9.5A2.25 2.25 0 0 1 19 7.25v9.5A2.25 2.25 0 0 1 16.75 19h-9.5A2.25 2.25 0 0 1 5 16.75v-9.5ZM8.25 15a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-1.5 0V15Zm3.75.75a.75.75 0 0 1-.75-.75V9.5a.75.75 0 0 1 1.5 0V15a.75.75 0 0 1-.75.75Zm2.25-.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-1.5 0V15Z",
    clipRule: "evenodd"
  })));
};
export default SvgDashboard;